import { type EnvironmentId, type ThreadId } from "@cmmd-forge/contracts";

export type ThreadDetailSubscriptionEntry = {
  readonly environmentId: EnvironmentId;
  readonly threadId: ThreadId;
  unsubscribe: () => void;
  unsubscribeConnectionListener: (() => void) | null;
  refCount: number;
  lastAccessedAt: number;
  evictionTimeoutId: ReturnType<typeof setTimeout> | null;
  lastEventAt: number;
  recoveryAttempts: number;
};

export const threadDetailSubscriptions = new Map<string, ThreadDetailSubscriptionEntry>();
